import { Center, Stack, Text } from 'ui';

const NoFees = () => {
  return (
    <Center mih="400px">
      <Stack gap="4">
        <Text fw={600} fz="lg" ta="center">
          No fees found
        </Text>
        <Text fz="sm" ta="center">
          No student fees are currently due.
        </Text>
      </Stack>
    </Center>
  );
};

export { NoFees };
